import React from 'react';
import { Button } from "react-bootstrap";
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { saveScoutGroup, resetScoutGroup } from '../../../actions/scout-kanban';
import { usePermission } from '../../../helpers/common';


const ActionButton = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { farmId } = useParams();
    const haveChanges = useSelector((state) => Object.keys(state.scoutKanban.sgListById).length > 0 ?
        Object.keys(state.scoutKanban.sgListById)
            .map(id => state.scoutKanban.sgListById[id])
            .filter(e => e && e.isChanged).length > 0 : false);
    const isRequestingSave = useSelector((state) => state.scoutKanban.isRequestingSave);
    const allow = usePermission();
    const isAllowCreateScoutGroup = allow("field-grouping", "create");
    const isAllowEdit = allow("field-grouping", "edit");
    const onSave = () => dispatch(saveScoutGroup(farmId));
    const onReset = () => dispatch(resetScoutGroup());
    const back = () => history.push(`/home/farm/${farmId}/map/sub=1`);

    return (
        <div>{(haveChanges && !isRequestingSave) && isAllowEdit &&
            <Button variant="outline-primary" size="sm" className="mr-3"
                title="Reset" onClick={onReset}>
                <i className="fa fa-refresh mr-1" />Reset
            </Button>}

            {isAllowCreateScoutGroup && <Button variant="primary" size="sm" className="mr-3" title="Save"
                disabled={/* isAssignCrewCall || */(isRequestingSave || !haveChanges)} onClick={onSave}>
                <i className="fa fa-floppy-o mr-1"></i> {isRequestingSave ? "Saving..." : "Save"}
            </Button>}
            <Button variant="danger" size="sm" className="mr-0" title="Cancel"
                disabled={isRequestingSave} onClick={back}>
                <i className="fa fa-times-circle mr-1"></i> Cancel
            </Button>
        </div>
    )
}

export default ActionButton
